import { AGENTIC_LOGIC_RULE_RUNS_DEFAULT_LIMIT } from "@intelligems/ig-types/dtos/agentic-logic/rule-runs";
import {
  AgenticLogicRuleRunsSource,
  ListAgenticLogicRuleRunsRequestPathParamsType,
  ListAgenticLogicRuleRunsRequestQueryParamsType,
  ListAgenticLogicRuleRunsResponseBodyType,
} from "@intelligems/ig-types/functions/agentic-logic/runs/list";
import { useQuery } from "@tanstack/react-query";

import { api } from "../api";
import { agenticLogicKeys } from "../queryKeys";

// Intelligems-staff only: the backend refuses a member token, so callers gate
// on `useIsAdmin()` and keep the query disabled until the view is open.

const listAgenticLogicRuleRuns = async (
  pathParams: ListAgenticLogicRuleRunsRequestPathParamsType,
  queryParams: ListAgenticLogicRuleRunsRequestQueryParamsType
) => {
  const resp = await api.get<ListAgenticLogicRuleRunsResponseBodyType>(
    `/v2/agentic-logic/rules/${pathParams.ruleId}/runs`,
    { params: queryParams }
  );
  return resp.data;
};

/**
 * `source: "history"` is the recorded trail (Snowflake, minutes behind) and
 * is read once; `source: "live"` is the short-lived store the serving broker
 * writes while a listen window is open, and is meant to be polled via
 * `refetchInterval` for as long as that window is open.
 */
export const useAgenticLogicRuleRuns = (
  ruleId: string | undefined,
  {
    limit = AGENTIC_LOGIC_RULE_RUNS_DEFAULT_LIMIT,
    source = "history",
    enabled = true,
    refetchInterval = false,
  }: {
    limit?: number;
    source?: AgenticLogicRuleRunsSource;
    enabled?: boolean;
    refetchInterval?: number | false;
  } = {}
) => {
  return useQuery<ListAgenticLogicRuleRunsResponseBodyType, Error>({
    queryKey: agenticLogicKeys.runs(ruleId!, limit, source),
    queryFn: async () =>
      listAgenticLogicRuleRuns({ ruleId: ruleId! }, { limit, source }),
    enabled: !!ruleId && enabled,
    refetchInterval,
  });
};
